// extracted by mini-css-extract-plugin
export default {"button":"WalletAndAddressButton_button__DIpyS","icon":"WalletAndAddressButton_icon__9uDEA"};